import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import LanguageSelect from "./pages/LanguageSelect";
import NotFound from "./pages/NotFound";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import PracticePage from "./practice/PracticePage";
import { practicePath } from "./practice/practiceContent";
import { LANG_CODES } from "./seo/site";
import ConsentBanner from "./analytics/ConsentBanner";

// Admin code (and Chakra) is split out of the public bundle.
const AdminProviders = lazy(() => import("./AdminProviders"));
const Admin = lazy(() => import("./pages/Admin"));
const Login = lazy(() => import("./pages/Login"));

const admin = (page) => (
  <Suspense fallback={null}>
    <AdminProviders>{page}</AdminProviders>
  </Suspense>
);

function App() {
  // Prerendered pages hide #root for desktop visitors until the first client
  // render has switched to their breakpoint (see public/index.html).
  useEffect(() => { document.documentElement.classList.remove("tk-wait"); }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LanguageSelect />} />
        {LANG_CODES.map((code) => (
          <Route key={code} path={`/${code}`} element={<Landing lang={code} />} />
        ))}
        {LANG_CODES.map((code) => (
          <Route key={`practice-${code}`} path={practicePath(code)} element={<PracticePage lang={code} />} />
        ))}
        <Route path="/admin" element={<Navigate to="/admin/questions" replace />} />
        <Route path="/admin/:tab" element={admin(<Admin />)} />
        <Route path="/admin/:tab/:id" element={admin(<Admin />)} />
        <Route path="/login" element={admin(<Login />)} />
        <Route path="/terms-of-service" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {/* Analytics cookie banner — hides itself on /admin and /login. */}
      <ConsentBanner />
    </Router>
  );
}

export default App;
